import type { ReactNode } from 'react';

export function Empty({ children }: { children: ReactNode }): JSX.Element {
  return <div className="p-6 text-gray-500 italic">{children}</div>;
}
